import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">关于色影视，你想知道的都在这里</p>

          <div className="space-y-3">
            {faqData.map((faq) => (
              <div
                key={faq.id}
                className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                  <span className="text-primary-500 shrink-0 mt-0.5">
                    <i className="ri-question-answer-line"></i>
                  </span>
                  {faq.question}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}